import React from 'react';
import { Box, Card } from '@mui/material';
import SkeletonLoader from './index';

const ConsultasSkeleton = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#FFFFFF",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "20px",
        paddingBottom: "100px",
        "&::-webkit-scrollbar": {
          display: "none",
        },
        scrollbarWidth: "none",
        msOverflowStyle: "none",
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }}
    >
      {/* Header skeleton */}
      <Box sx={{ 
        width: "100%",
        maxWidth: "800px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginBottom: "40px",
        marginTop: "20px",
        position: "relative",
        px: 2
      }}>
        <SkeletonLoader
          variant="text"
          width={120}
          height={32}
          sx={{ 
            backgroundColor: '#f0f0f0',
            borderRadius: '8px'
          }}
        />
        <SkeletonLoader
          variant="circular"
          width={32}
          height={32}
          sx={{ 
            backgroundColor: '#f0f0f0',
            position: "absolute",
            right: 0
          }}
        />
      </Box>

      {/* Sección de Próximas Consultas skeleton */}
      <Box sx={{ 
        width: "100%",
        maxWidth: "800px",
        px: 2
      }}>
        <SkeletonLoader
          variant="text"
          width={180}
          height={24}
          sx={{ 
            mb: 2,
            backgroundColor: '#f0f0f0',
            borderRadius: '8px'
          }}
        />

        {/* Lista de Consultas skeleton - Mostrar 3 cards de ejemplo */}
        {[1, 2].map((index) => (
          <Card
            key={index}
            sx={{
              mb: 2,
              p: 2,
              borderRadius: '12px',
              boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
              border: 'none',
              backgroundColor: '#fff'
            }}
          >
            <Box sx={{ 
              display: 'flex', 
              alignItems: 'center',
              justifyContent: 'space-between'
            }}>
              {/* Avatar y Nombre skeleton */}
              <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                <SkeletonLoader
                  variant="circular"
                  width={50}
                  height={50}
                  sx={{ 
                    mr: 2,
                    backgroundColor: '#f0f0f0'
                  }}
                />
                
                <Box sx={{ flex: 1 }}>
                  <SkeletonLoader
                    variant="text"
                    width={150}
                    height={20}
                    sx={{ 
                      mb: 0.5,
                      backgroundColor: '#f0f0f0',
                      borderRadius: '8px'
                    }}
                  />
                </Box>
              </Box>

              {/* Iconos de Acción skeleton */}
              <Box sx={{ 
                display: 'flex', 
                alignItems: 'center',
                gap: 1
              }}>
                <SkeletonLoader
                  variant="circular"
                  width={24}
                  height={24}
                  sx={{ backgroundColor: '#f0f0f0' }}
                />
         
                
              </Box>
            </Box>

            {/* Línea divisora skeleton */}
            <Box sx={{ 
              height: '1px',
              backgroundColor: '#F0F0F0',
              mx: 0.5,
              mt: 1.5
            }} />

            {/* Fecha y Hora skeleton */}
            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'space-between',
              mt: 1.5,
              px: 0.5
            }}>
              <SkeletonLoader
                variant="text"
                width={100}
                height={16}
                sx={{ 
                  backgroundColor: '#f0f0f0',
                  borderRadius: '8px'
                }}
              />
              <SkeletonLoader
                variant="text"
                width={120}
                height={16}
                sx={{ 
                  backgroundColor: '#f0f0f0',
                  borderRadius: '8px'
                }}
              />
            </Box>
          </Card>
        ))}
      </Box>
    </Box>
  );
};

export default ConsultasSkeleton;
